import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {ContentHomeAboutVo} from '../../common/shared/api/nicolas/vo/ContentHomeAboutVo.interface';

/**
 * 콘텐츠 홈 소개 정보 조회
 *
 * Origin: pageNicolasApi.getContentHomeAbout
 * API: GET /api/v1/content/about
 */
export async function getContentAbout(
  {
    seriesId,
  }: {
    seriesId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: ContentHomeAboutVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/content/about',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
      },
    },
    options
  );
  return response.data;
}
